"use client";
import { jsx as n } from "react/jsx-runtime";
import { memo as p } from "react";
import { THEMES as a } from "../../constants/themes.js";
import r from "../img/Img.js";
import l from "classnames";
import '../../assets/Shape.css';const i = "_shape_1q9cm_9", q = "_s1_1q9cm_24", f = "_s3_1q9cm_24", y = "_s6_1q9cm_24", h = "_s2_1q9cm_27", u = "_plenty_1q9cm_30", d = "_s4_1q9cm_36", N = "_s5_1q9cm_36", S = "_s7_1q9cm_36", s = {
  shape: i,
  s1: q,
  s3: f,
  s6: y,
  s2: h,
  plenty: u,
  s4: d,
  s5: N,
  s7: S
}, $ = p(({ className: _, color: c, shape: t, theme: m = a.BOLT, priority: o }) => {
  const e = `design-system/shapes/${m}/${t}-${c}`;
  return /* @__PURE__ */ n(
    r,
    {
      publicId: e,
      priority: o,
      alt: "",
      objectFit: "fromClassName",
      fill: !0,
      className: l(s.shape, s[t], s[m], _),
      steps: 800
    }
  );
});
$.displayName = "Shape";
export {
  $ as default
};
